import { defineFcm } from '../shared/factory';

export const FCM_PACIFIC_DISABLE_COMMS_AA_EDITORIAL_RECENT_STARTER_SUPRESSION = defineFcm(
	'pacific_disable_comms_aa_editorial_recent_starter_supression',
)
	.asBoolean()
	.withDefault(false)
	.toConfig();
